import React from 'react'

/** Lotus My Favorites sidebar star icon (24x24 SVG) */
const FavoriteMenuIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <defs>
      <style>{`
        .fav-st0 { fill: none; }
        .fav-st1 { fill: url(#fav-linear-gradient1); }
        .fav-st2 { fill: url(#fav-linear-gradient); }
        .fav-st3 { fill: #fff; opacity: .5; }
        .fav-st4 { isolation: isolate; }
        .fav-st5 { fill: #ffe576; }
        .fav-st6 { clip-path: url(#fav-clippath); }
      `}</style>
      <clipPath id="fav-clippath">
        <rect width="24" height="24" className="fav-st0" />
      </clipPath>
      <linearGradient
        id="fav-linear-gradient"
        x1="13.6"
        y1="19.3"
        x2="10.2"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ffb427" />
        <stop offset="0.5" stopColor="#ffc822" />
        <stop offset="0.9" stopColor="#ffda1f" />
      </linearGradient>
      <linearGradient
        id="fav-linear-gradient1"
        x1="14.2"
        y1="22.5"
        x2="10.6"
        y2="2.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff9500" />
        <stop offset="0.9" stopColor="#ffba18" />
      </linearGradient>
    </defs>
    <g className="fav-st4">
      <g className="fav-st6">
        <path
          d="M10,10c-1,.5-5.2,0-7.5-.5v-.5l6.5-1,2.5-5c0,2.8-.4,6.5-1.5,7Z"
          className="fav-st3"
        />
      </g>
    </g>
    <g>
      <path
        d="M21.1,8.9l-5.7-.8-2.6-5.1c0-.2-.2-.3-.4-.4-.2,0-.3-.1-.5-.1-.2,0-.4,0-.5.1-.2,0-.3.2-.4.4l-2.5,5.2-5.7.9c-.2,0-.3,0-.4.2-.1,0-.2.2-.3.3-.1.2-.2.4-.1.6,0,.2.1.4.3.6l4.2,4-.9,5.6c0,.2,0,.3,0,.5,0,.1.1.3.2.4.1.2.3.3.6.3.2,0,.4,0,.6-.1l5.1-2.7,5.1,2.6c.2.1.4.1.6,0,.2,0,.4-.2.6-.3,0-.1.2-.3.2-.4,0-.1,0-.3,0-.5l-1-5.6,4.1-4c.2-.2.3-.4.3-.6,0-.2,0-.4-.1-.6,0-.1-.2-.2-.3-.3-.1,0-.3-.1-.4-.1Z"
        className="fav-st2"
      />
      <path
        d="M6.8,20.9l1-6.1s-4.8-4.4-4.9-4.6c-.3-.8.9-.7,1-.7l5.4-.8,2.6-5.3c0-.2.2-.3.4-.4,0,0,0,0,0,0-.1,0-.3-.1-.4-.1-.2,0-.4,0-.5.1-.2,0-.3.2-.4.4l-2.5,5.1-5.5.9c-.1,0-.3,0-.4.2-.1,0-.2.2-.3.3-.1.2-.2.4-.1.6,0,.2.1.4.3.6l4.1,3.9-.9,5.5c0,.1,0,.3,0,.4s.1.3.2.4c.1.2.3.3.6.3.2,0,.4,0,.6,0-.1,0-.4-.3-.3-.4Z"
        className="fav-st5"
      />
      <path
        d="M10.3,10.9c-1,.5-5.6-.3-7.9-.8,0,0,.1-.6.7-.7l5.8-.9,2.6-5.3c0,2.8-.1,7.1-1.2,7.6Z"
        className="fav-st3"
      />
      <path
        d="M6.5,22c0,0-.2,0-.2,0-.3,0-.6-.2-.8-.5-.2-.2-.3-.4-.3-.6,0-.2,0-.5,0-.7l.9-5.3-4-3.8c-.2-.2-.4-.5-.4-.9,0-.3,0-.7.2-1,.1-.2.3-.4.5-.5s.4-.2.6-.2l5.4-.8,2.4-4.9c.1-.2.3-.5.5-.6.2-.1.5-.2.8-.2.3,0,.5,0,.8.2.2.1.4.3.5.6l2.5,4.9,5.4.7c.2,0,.4,0,.6.2.2.1.4.3.5.5.2.3.3.6.2,1,0,.3-.2.6-.4.9l-3.9,3.8,1,5.3c0,.2,0,.4,0,.7,0,.2-.2.4-.3.6-.2.3-.5.4-.8.5-.3,0-.7,0-1-.1l-4.9-2.5-4.9,2.6c-.2.1-.5.2-.7.2ZM11.9,3c0,0-.2,0-.3,0,0,0-.1.1-.2.2l-2.6,5.4-5.9.9c0,0-.2,0-.2,0,0,0-.1,0-.2.2,0,0,0,.2,0,.3,0,.1,0,.2.1.3l4.4,4.1-1,5.9c0,0,0,.2,0,.2s0,.1.1.2c0,0,.2.1.3.1.1,0,.2,0,.3,0l5.3-2.8,5.4,2.7c0,0,.2,0,.3,0,.1,0,.2,0,.3-.2,0,0,0-.1,0-.2,0,0,0-.2,0-.2l-1.1-5.9,4.3-4.2c0,0,.1-.2.1-.3,0-.1,0-.2,0-.3,0,0,0-.1-.2-.2s-.1,0-.2,0h0s-5.9-.8-5.9-.8l-2.7-5.3c0,0-.1-.1-.2-.2,0,0-.2,0-.3,0Z"
        className="fav-st1"
      />
    </g>
  </svg>
)

export default FavoriteMenuIcon
